export default __webpack_public_path__ + "static/Agro-logo-e91d52108347e9c81bb65540c37a9ff2.svg";